import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { AppNavigation } from '@app/app.navigation';
import { PageNotFoundComponent } from '@core/components/page-not-found/page-not-found.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { CanDeactivateGuard } from '@core/guards/can-deactivate.guard';
import { UnauthGuard } from '@core/guards/unauth.guard';

export const ANCHOR_SCROLLING_OFFSET_PX = 120;

const routes: Routes = [
  {
    path: AppNavigation.Dashboard,
    loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canLoad: [AuthGuard],
  },
  {
    path: AppNavigation.Login,
    loadChildren: () => import('./pages/login-page/login-page.module').then((m) => m.LoginPageModule),
    data: { noHeader: true },
    canLoad: [UnauthGuard],
  },
  {
    path: '',
    redirectTo: `/${AppNavigation.Dashboard}`,
    pathMatch: 'full',
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, ANCHOR_SCROLLING_OFFSET_PX],
      enableTracing: false,
      preloadingStrategy: NoPreloading,
    }),
  ],
  providers: [AuthGuard, CanDeactivateGuard, UnauthGuard],
  exports: [RouterModule],
})
export class AppRoutingModule {}
